import * as tslib_1 from "tslib";
import { Model, RouteScope } from './../model';
import { WorkerViewPort } from './../worker-port';
var AppModel = (function (_super) {
    tslib_1.__extends(AppModel, _super);
    function AppModel(port) {
        var _this = _super.call(this, 'app') || this;
        _this._appModel = _this;
        if (port === undefined) {
            port = new WorkerViewPort(_this);
        }
        _this._port = port;
        _this._routeScope = new RouteScope(_this);
        _this._descendantModels = {};
        _this._descendantModels[_this._id] = _this;
        _this._lastRefreshTime = 0;
        _this._refreshTimer = 0;
        _this.onRefresh = _this.onRefresh.bind(_this);
        return _this;
    }
    Object.defineProperty(AppModel.prototype, "appModel", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "routeScope", {
        get: function () {
            return this._routeScope;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppModel.prototype, "parentScope", {
        get: function () {
            return this._routeScope;
        },
        enumerable: true,
        configurable: true
    });
    AppModel.prototype.getModel = function (modelId) {
        return this._descendantModels[modelId];
    };
    AppModel.prototype.addDescendantModels = function (childModel, parentModel) {
        if (!this._descendantModels[childModel._id]) {
            this._descendantModels[childModel._id] = childModel;
            childModel.setAppModel(this);
        }
        for (var i = 0; i < childModel._childModels.length; i += 1) {
            this.addDescendantModels(childModel._childModels[i], childModel);
        }
    };
    AppModel.prototype.removeDescendantModels = function (childModel, parentModel) {
        for (var i = 0; i < childModel._childModels.length; i += 1) {
            this.removeDescendantModels(childModel._childModels[i], childModel);
        }
        if (this._descendantModels[childModel._id]) {
            childModel.setAppModel(null);
            delete this._descendantModels[childModel._id];
        }
    };
    AppModel.prototype.appendChildView = function (parentId, childId, viewDef) {
        if (arguments.length === 2) {
            viewDef = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._port.appendChild(parentId, childId, viewDef);
    };
    AppModel.prototype.prependChildView = function (parentId, childId, viewDef) {
        if (arguments.length === 2) {
            viewDef = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._port.prependChild(parentId, childId, viewDef);
    };
    AppModel.prototype.insertChildView = function (parentId, childId, targetId, viewDef) {
        if (arguments.length === 3) {
            viewDef = targetId;
            targetId = childId;
            childId = parentId;
            parentId = this._id;
        }
        this._port.insertChild(parentId, childId, targetId, viewDef);
    };
    AppModel.prototype.removeChildView = function (parentId, childId) {
        if (arguments.length === 1) {
            childId = parentId;
            parentId = this._id;
        }
        this._port.removeChild(parentId, childId);
    };
    AppModel.prototype.setState = function (newState, parentModel) {
        if (parentModel === undefined) {
            _super.prototype.setState.call(this, newState);
        }
        else {
            this._port.setState(parentModel._id, newState);
        }
    };
    AppModel.prototype.requestRestate = function () {
        if ((this._flags & Model.REQUEST_RESTATE) === 0) {
            this._flags |= Model.REQUEST_RESTATE;
            if (!this._refreshTimer) {
                this._refreshTimer = setTimeout(this.onRefresh, 1 / 60);
            }
        }
    };
    AppModel.prototype.onRefresh = function () {
        this._refreshTimer = 0;
        if ((this._flags & Model.REQUEST_RESTATE) !== 0) {
            this.cascadeWillRestate();
            this.cascadeDidRestate();
        }
    };
    return AppModel;
}(Model));
export { AppModel };
Model.AppModel = AppModel;
//# sourceMappingURL=data:application/json;base64,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